import { render, staticRenderFns } from "./advert.vue?vue&type=template&id=2c1a02c7&scoped=true"
import script from "./advert.vue?vue&type=script&lang=js"
export * from "./advert.vue?vue&type=script&lang=js"
import style0 from "./advert.vue?vue&type=style&index=0&id=2c1a02c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a02c7",
  null
  
)

export default component.exports